<template>
  <div class="lib__form__announcement">
    <h2 class="lib__text-alert">
      <i class="far fa-times-circle"></i>
      {{ $t('prosumerBonus.formAlreadyCompleted.title') }}
    </h2>
    <p data-cy="send-confirmation-message" v-html="$t('prosumerBonus.formAlreadyCompleted.message')"></p>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { PersonalInfo } from '@/models'

@Component({ name: 'send-confirmation' })
export default class FormAlreadyCompleted extends Vue {
}
</script>